;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingViewTipsListForAflClubs = Marionette.ItemView.extend({
		template: JST.TippingViewTipsListForAflClubs,
		collectionEvents: {
			'sync': 'precessRequest'
		},
		ui: {
			'show_more': '.js-load-more',
			'swipe_table':  '.js-swipe-table',
			'tipped_table': '.tipping-table'
		},
		events: {
			'click @ui.show_more': 'showMore'
		},

		initialize: function(){

			this.showPreloader();

			this.rounds = this.getOption('rounds');
			this.league_id = this.getOption('league_id');
			this.league = this.getOption('league');

			this.model.set({
				id: this.league_id,
				offset: 0,
				limit: 10,
				show_more: false
			});

			this.initListeners();

			var requests = [this.rounds.fetch(), this.league.show().fetch({ data: { id: this.league_id } })];

			$.when.apply(null, requests)
				.then(this.initModel.bind(this))
				.then(this.fetchViewCollection.bind(this));

		},

		initListeners: function(){
			this.on('change:rounds:control', this.setModel);

			return this;
		},

		initModel: function(){
			var rd = this.rounds.getLastGameRound('id');
			rd.set('selected', true);
			this.model.set({
				round: rd.get('id'),
				matches: rd.get('matches')
			});

			this.trigger('rounds:fetched', this.rounds);
			this.trigger('leagues:view:menu', this.league, this.rounds);

			return this;
		},

		setModel: function(options){
            var r = this.rounds.get(options.round);
            r.set('selected', true);
			this.showPreloader();
            this.model.set({
                round: r.get('id'),
                matches: r.get('matches')
            });
            this.model.set(_.extend(options, {offset: 0}));
			this.fetchViewCollection();
		},

		fetchViewCollection: function() {
			var data = _.pick(this.model.toJSON(), 'id', 'round', 'offset', 'limit');
			return this.collection.leagueTips()
				.fetch({
					silent:true,
					data: data
				});
		},

		precessRequest: function(){

			this.model.set({
				show_more: this.collection.size() == 10,
				matches_tip: this.convertMatchesTip()
			});

			this.render()
				.hidePreloader();

			this.initSwipeTable();
		},

		initSwipeTable: function(){

			this.ui.swipe_table.swipeTable();
			this.ui.tipped_table.show();


		},

		convertMatchesTip: function(){

			var matches_tip = this.collection.toJSON();
			var matches = this.model.get('matches');

			matches_tip.forEach(function(state){

				state['avatars_url'] = CONFIG.AVATARS_URL + state.user_id + '.png';

				if( !state.rank ){
					state.rank = '-';
				}

				var tips_icon = [];

				_.map( matches, _.bind(function(match, key){

					var tip = _.find(state.tips, {match_id: match.id});

					if( tip ){

						tips_icon.push({'predict_winner_squad_img': '<img src="' + CONFIG.SQUADS_URL + 'flags/' + tip.predict_winner_squad_id + '.png " alt="">' });
					}else{

						tips_icon.push({'predict_winner_squad_img': '-' });
					}

				}, this));

				state['tips_icon'] = tips_icon;

			});

			return matches_tip;

		},

		showMore: function(){

			this.model.set({
				offset: this.model.get('limit')
			});

			var data = _.pick(this.model.toJSON(), 'id', 'round', 'offset', 'limit');
			return this.collection.leagueTips()
				.fetch({
					silent:true,
					remove:false,
					data: data
				});
		}

	});

}(window, APP, Backbone, Marionette, $, _));